import { render, staticRenderFns } from "./EditContatto.vue?vue&type=template&id=75b02fb6&"
import script from "./EditContatto.vue?vue&type=script&lang=ts&"
export * from "./EditContatto.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports